module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-helper-wrapper"
  }, [_c('div', {
    staticClass: "box-helper-button",
    on: {
      "click": function($event) {
        return _vm.showHelper()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "box-helper",
    on: {
      "click": function($event) {
        return _vm.hideHelper()
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "html",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fas fa-question fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close"
  }, [_c('i', {
    staticClass: "fas fa-times fa-fw"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2eeed00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/BoxHelper.vue
// module id = 923
// module chunks = 0